import { render, staticRenderFns } from "./OnlyView.vue?vue&type=template&id=31bf866e&scoped=true&"
import script from "./OnlyView.vue?vue&type=script&lang=js&"
export * from "./OnlyView.vue?vue&type=script&lang=js&"
import style0 from "./OnlyView.vue?vue&type=style&index=0&id=31bf866e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf866e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31bf866e')) {
      api.createRecord('31bf866e', component.options)
    } else {
      api.reload('31bf866e', component.options)
    }
    module.hot.accept("./OnlyView.vue?vue&type=template&id=31bf866e&scoped=true&", function () {
      api.rerender('31bf866e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/production/jobcard/jobcard-view/components/OnlyView.vue"
export default component.exports